import client from "../../../api/client";

export default async function updateCompleteUserProfile(payload) {
  const response = await client.put("/user/complete-user-profile", payload);
  return response.data;
}